import { BasicController } from "@goodgamestudios/core";
import { BasicStandardOkDialogProperties } from "@goodgamestudios/core";
import { CommandController } from "@goodgamestudios/core";
import { LanguageDataEvent } from "@goodgamestudios/core";
import { TextFieldHelper } from "@goodgamestudios/core";
import { TextValide } from "@goodgamestudios/core";

import { KeyboardEvent } from "@goodgamestudios/createjs-utilities";
import { Keyboard } from "@goodgamestudios/createjs-utilities";

import { Poker2DialogEvent } from "../../event/Poker2DialogEvent";
import { Poker2UserEvent } from "../../event/Poker2UserEvent";
import { Poker2Model } from "../../model/Poker2Model";
import { InputFieldConstants } from "../constants/InputFieldConstants";
import { Poker2Panel } from "./Poker2Panel";

import DisplayObject = createjs.DisplayObject;
import Event = createjs.Event;
import FocusEvent = createjs.FocusEvent;
import MouseEvent = createjs.MouseEvent;

export class Poker2LoginPanel extends Poker2Panel {
    public static NAME: string = "Poker2LoginPanel";

    private preset_name: string = "";
    private preset_pass: string = "";
    private isWaitingForServerMessage: boolean = false;
    private _btnAvatar: DefaultButton;

    constructor(disp: DisplayObject) {
        CONSTRUCTOR_HACK;
        super(disp);
    }

    protected init(): void {
        super.init();
        // TODO @HTML5 - Poker2Model.localData.readData();
        this.loginPanel.input_password.inputField.displayAsPassword = true;
        this.loginPanel.input_loginName.inputField.tabIndex = 10;
        this.loginPanel.input_loginName.inputField.alpha = InputFieldConstants.INPUT_EMPTY_ALPHA;
        this.loginPanel.input_password.inputField.tabIndex = 11;
        this.loginPanel.input_password.inputField.alpha = InputFieldConstants.INPUT_EMPTY_ALPHA;
        this.preset_name = Poker2Model.languageData.getTextById("generic_login_loginname");
        this.preset_pass = Poker2Model.languageData.getTextById("generic_login_password");

        this.controller.addEventListener("changelayoutstate", this.bindFunction(this.onLayerChange));
        this.controller.addEventListener("logginFaild", this.bindFunction(this.onResetWaiting));
        this.controller.addEventListener(Poker2DialogEvent.ON_HIDE, this.bindFunction(this.showInputWhenLoadPWDialogHide));

        this.loginPanel.input_loginName.inputField.addEventListener(KeyboardEvent.KEY_UP, this.bindFunction(this.onEnterUsername));
        this.loginPanel.input_password.inputField.addEventListener(KeyboardEvent.KEY_UP, this.bindFunction(this.onEnterPassword));
        this.loginPanel.input_loginName.inputField.addEventListener(FocusEvent.FOCUS_IN, this.bindFunction(this.onEnterUsername));
        this.loginPanel.input_password.inputField.addEventListener(FocusEvent.FOCUS_IN, this.bindFunction(this.onEnterPassword));
        this.loginPanel.input_loginName.inputField.addEventListener(FocusEvent.FOCUS_OUT, this.bindFunction(this.refillEmptyInputFields));
        this.loginPanel.input_password.inputField.addEventListener(FocusEvent.FOCUS_OUT, this.bindFunction(this.refillEmptyInputFields));

        this.loginPanel.btn_lostpass.visible = false;
    }

    public destroy(): void {
        super.destroy();
        this.controller.removeEventListener("changelayoutstate", this.bindFunction(this.onLayerChange));
        this.controller.removeEventListener("logginFaild", this.bindFunction(this.onResetWaiting));
        this.controller.removeEventListener(Poker2DialogEvent.ON_HIDE, this.bindFunction(this.showInputWhenLoadPWDialogHide));

        this.loginPanel.input_loginName.inputField.removeEventListener(KeyboardEvent.KEY_UP, this.bindFunction(this.onEnterUsername));
        this.loginPanel.input_password.inputField.removeEventListener(KeyboardEvent.KEY_UP, this.bindFunction(this.onEnterPassword));
        this.loginPanel.input_loginName.inputField.removeEventListener(FocusEvent.FOCUS_IN, this.bindFunction(this.onEnterUsername));
        this.loginPanel.input_password.inputField.removeEventListener(FocusEvent.FOCUS_IN, this.bindFunction(this.onEnterPassword));
        this.loginPanel.input_loginName.inputField.removeEventListener(FocusEvent.FOCUS_OUT, this.bindFunction(this.refillEmptyInputFields));
        this.loginPanel.input_password.inputField.removeEventListener(FocusEvent.FOCUS_OUT, this.bindFunction(this.refillEmptyInputFields));
    }

    protected onFontsLoaded(event: LanguageDataEvent): void {
        this.updateLanguage();
    }

    private updateLanguage(): void {
        // update model
        // TODO @HTML5 Poker2Model.localData.readData();
        this.loginPanel.input_password.inputField.displayAsPassword = true;
        this.loginPanel.input_password.inputField.tabIndex = 11;
        this.loginPanel.input_password.inputField.alpha = InputFieldConstants.INPUT_EMPTY_ALPHA;
        this.loginPanel.input_loginName.inputField.tabIndex = 10;
        this.loginPanel.input_loginName.inputField.alpha = InputFieldConstants.INPUT_EMPTY_ALPHA;
        this.preset_name = Poker2Model.languageData.getTextById("generic_login_loginname");
        this.preset_pass = Poker2Model.languageData.getTextById("generic_login_password");

        this.update();
    }

    private onResetWaiting(event: Poker2UserEvent): void {
        this.isWaitingForServerMessage = false;
        this.loginPanel.input_loginName.inputField.text = Poker2Model.userData.userName;
        this.loginPanel.input_loginName.inputField.alpha = InputFieldConstants.INPUT_FILLED_ALPHA;
    }

    private onEnterUsername(event: Event): void {
        if (this.loginPanel.input_loginName.inputField.text == this.preset_name) {
            this.loginPanel.input_loginName.inputField.text = "";
            this.loginPanel.input_loginName.inputField.alpha = InputFieldConstants.INPUT_EMPTY_ALPHA;
        }
        else {
            this.loginPanel.input_loginName.inputField.alpha = InputFieldConstants.INPUT_FILLED_ALPHA;
        }
    }

    private onEnterPassword(event: Event): void {
        if (this.loginPanel.input_password.inputField.text == this.preset_pass) {
            this.loginPanel.input_password.inputField.text = "";
            this.loginPanel.input_password.inputField.alpha = InputFieldConstants.INPUT_EMPTY_ALPHA;
            this.loginPanel.input_password.inputField.displayAsPassword = true;
        }
        else {
            this.loginPanel.input_password.inputField.alpha = InputFieldConstants.INPUT_FILLED_ALPHA;
        }
    }

    private refillEmptyInputFields(event: Event = null): void {
        if (this.loginPanel.input_loginName.inputField.text == "") {
            this.loginPanel.input_loginName.inputField.text = this.preset_name;
            this.loginPanel.input_loginName.inputField.alpha = InputFieldConstants.INPUT_EMPTY_ALPHA;
        }

        if (this.loginPanel.input_password.inputField.text == "") {
            this.loginPanel.input_password.inputField.text = this.preset_pass;
            this.loginPanel.input_password.inputField.alpha = InputFieldConstants.INPUT_EMPTY_ALPHA;
            this.loginPanel.input_password.inputField.displayAsPassword = false;
        }
    }

    protected update(): void {
        this.loginPanel.btn_login.minWidth = 50;
        this.loginPanel.btn_login.label = Poker2Model.languageData.getTextById("generic_login_login");

        if (!this._btnAvatar) {
            // not using BasicButton, due to the button should not change its width
            this._btnAvatar = new DefaultButton(this.loginPanel.btn_avatar);
        }
        this._btnAvatar.label = Poker2Model.languageData.getTextById("generic_login_playnow");

        TextFieldHelper.changeTextFromatSizeByTextWidth(10, this.loginPanel.txt_savedata, Poker2Model.languageData.getTextById("generic_login_rememberpassword"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(10, this.loginPanel.btn_lostpass.txt_label, Poker2Model.languageData.getTextById("generic_login_lostpassword"));
        this.loginPanel.input_loginName.inputField.text = Poker2Model.localData.readLoginDataUsername();
        this.loginPanel.input_loginName.inputField.alpha = InputFieldConstants.INPUT_FILLED_ALPHA;
        this.loginPanel.input_password.inputField.text = Poker2Model.localData.readLoginDataPass();
        this.loginPanel.input_password.inputField.alpha = InputFieldConstants.INPUT_FILLED_ALPHA;
        this.loginPanel.input_loginName.inputField.visible = true;
        this.loginPanel.input_password.inputField.visible = true;
        this.refillEmptyInputFields();

        this.loginPanel.btn_checkData.isSelected = Poker2Model.localData.readLoginDataSave();

        this.unLockPanel();
    }

    private showInputWhenLoadPWDialogHide(e: Poker2DialogEvent) {
        if(e.type == Poker2DialogEvent.ON_HIDE && e.params && e.params[0] == "Poker2LostPasswordDialog") {
            this.loginPanel.input_loginName.inputField.visible = true;
            this.loginPanel.input_password.inputField.visible = true;
        }
    }

    protected onClick(event: MouseEvent): void {
        if (this.isLocked)
            return;
        super.onClick(event);

        switch (event.target) {
            case this.loginPanel.btn_login:
                this.onLogin();
                break;
            case this.loginPanel.btn_checkData:
                this.loginPanel.btn_checkData.toggleSelected();
                break;
            case this.loginPanel.btn_avatar:
                this.loginPanel.input_loginName.inputField.visible = false;
                this.loginPanel.input_password.inputField.visible = false;
                this.layoutManager.showDialog("Poker2AvatarCreationDialog");
                break;
            case this.loginPanel.input_password.inputField:
            case this.loginPanel.input_loginName.inputField:
                //					(event.target as TextField).setSelection( (event.target as TextField).text.length, (event.target as TextField).text.length );
                break;
            case this.loginPanel.btn_lostpass:
                this.loginPanel.input_loginName.inputField.visible = false;
                this.loginPanel.input_password.inputField.visible = false;
                this.layoutManager.showDialog("Poker2LostPasswordDialog");
                break;
            case this.loginPanel.btn_facebook:
                //TODO
                break;
        }
    }

    protected onKeyUp(event: KeyboardEvent): void {
        switch (event.target) {
            case this.loginPanel.input_loginName.inputField:
            case this.loginPanel.input_password.inputField:
                if (event.key == Keyboard.ENTER)
                    this.onLogin();
                break;
        }
    }

    public show(): void {
        super.show();
        this.isWaitingForServerMessage = false;
        this.update();
    }

    private onLayerChange(e: Poker2DialogEvent): void {
        this.isWaitingForServerMessage = false;
    }

    private onLogin(): void {
        if (this.isWaitingForServerMessage)
            return;

        if ((this.loginPanel.input_loginName.inputField.text == this.preset_name || !TextValide.isSmartFoxValide(this.loginPanel.input_loginName.inputField.text)) || (this.loginPanel.input_password.inputField.text == this.preset_pass || !TextValide.isSmartFoxValide(this.loginPanel.input_password.inputField.text))) {
            this.layoutManager.showDialog("Poker2WarningDialog", new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("generic_alert_information"), Poker2Model.languageData.getTextById("generic_login_wronglogin")));
            return;
        }
        this.isWaitingForServerMessage = true;

        Poker2Model.userData.userName = this.loginPanel.input_loginName.inputField.text.trim();
        Poker2Model.userData.loginPwd = this.loginPanel.input_password.inputField.text.trim();

        if (this.loginPanel.btn_checkData.isSelected) {
            Poker2Model.localData.saveLoginData(Poker2Model.userData.userName, Poker2Model.userData.loginPwd, true);
        } else {
            Poker2Model.localData.saveLoginData("", "", false);
        }

        CommandController.instance.executeCommand(BasicController.COMMAND_LOGIN);
    }

    public updatePosition(): void {
        super.updatePosition();

        if (this.disp && this.disp.stage) {
            this.disp.y = 600 * this.disp.scaleY; //disp.stage.stageHeight;
            this.disp.x = this.disp.stage.stageWidth / 2;
        }
    }

    private get loginPanel(): Library.PokerInterface.PokerLogin {
        return this.disp as Library.PokerInterface.PokerLogin;
    }
}
import { DefaultButton } from "../components/button/DefaultButton";
import { Poker2LostPasswordDialog } from "../dialogs/Poker2LostPasswordDialog";
import { Poker2WarningDialog } from "../dialogs/Poker2WarningDialog";
import { Poker2AvatarCreationDialog } from "../dialogs/registration/Poker2AvatarCreationDialog";
import { Poker2LayoutManager } from "../Poker2LayoutManager";
